import React from 'react';
import { PropTypes } from 'prop-types';

const Holidays = ({ className, holidays, hasHolidays, nextHolidays }) => (
  <div className={`${className} ${hasHolidays ? 'holidays' : ''}`}>
    {hasHolidays && (
      <>
        <b>{nextHolidays}</b> {holidays}
      </>
    )}
  </div>
);

Holidays.propTypes = {
  className: PropTypes.string,
  holidays: PropTypes.arrayOf(PropTypes.strings),
  hasHolidays: PropTypes.bool,
  nextHolidays: PropTypes.string,
};

Holidays.defaultProps = {
  className: '',
  holidays: [],
  hasHolidays: false,
  nextHolidays: '',
};

export default Holidays;
